import { FC, useState } from "react"
import { expandPanel, expandedPanelsAtom } from "@/store/ui-views-state"
import { useAtomValue } from "jotai"
import { ExpandablePanelCommonProps, ExpandablePanel } from "./ExpandablePanel"

type ControlGroupProps = ExpandablePanelCommonProps & {
	expandKey?: string
	isExpanded?: boolean
	onExpandedChange?: (expanded: boolean) => void
}

export const ControlGroup: FC<ControlGroupProps> = (props) => {
	const expandedPanels = useAtomValue(expandedPanelsAtom)
	const [isExpandedTemp, setIsExpandedTemp] = useState(props.isExpanded)
	const isExpanded = props.expandKey ? expandedPanels[props.expandKey] : isExpandedTemp

	const handleToggleExpanded = (expanded: boolean) => {
		setIsExpandedTemp(expanded)
		if (props.expandKey) {
			expandPanel(props.expandKey, expanded)
		}
		props.onExpandedChange?.(expanded)
	}

	return (
		<ExpandablePanel
			{...props}
			isExpanded={!!isExpanded}
			onToggleExpanded={handleToggleExpanded}
		/>
	)
}
